// ViewInstructionModal.js

import React from 'react';
import '../../style/ViewInstructionModal.css';

const ViewInstructionModal = ({ instruction, onClose }) => {
    const { title, text, media } = instruction;

    return (
        <div className="modal">
            <div className="modal-content">
                <button className="close-button" onClick={onClose}>×</button>
                <h2>{title}</h2>

                {media && media.endsWith('.mp4') && (
                    <video controls width="100%">
                        <source src={`https://46.101.187.155:3000/${media}`} type="video/mp4" />
                        Ваш браузер не поддерживает видео.
                    </video>
                )}

                <p>{text}</p>
            </div>
        </div>
    );
};

export default ViewInstructionModal;
